import { SafeAreaProvider as SafeAreaProviderDefault } from 'react-native-safe-area-context'
import styled from 'styled-components/native'

export const SafeAreaProvider = styled(SafeAreaProviderDefault)({
  height: '100%',
})
